"use client";

import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { FiCheckCircle } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentChecklist, fetchChecklistDetails, selectCurrentChecklist,selectIsLoading as selectChecklistLoading,} from "../../../redux/features/clientChecklistSlice";
import { getVisaLabelByValue } from "../dashboard/staticData";

export default function ApplicationHeader({ propsData }) {
  const { id } = useParams();
  const dispatch = useDispatch()
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const newData = useSelector((state) => state.createApplication.newData);
    const checklistLoading = useSelector(selectChecklistLoading)
  
    const checklist = useSelector(selectCurrentChecklist)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    to:""
  });

    useEffect(() => {
      dispatch(clearCurrentChecklist())
    }, [dispatch])
  
    // Fetch checklist data when component mounts or when country/visaCategory changes
    useEffect(() => {

      if (propsData.countryOfInterest && propsData.visaCategory) {
        dispatch(
          fetchChecklistDetails({
            country: propsData.countryOfInterest,
            visaCategory: propsData.visaCategory,
          }),
        )
      }
    }, [propsData.countryOfInterest, propsData.visaCategory, dispatch])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    // Check if any field is empty
    if (!formData.subject || !formData.message) {
      setError("Please fill all fields"); // Show error on frontend
      return;
    }

    // Get the token from localStorage
    const token = localStorage.getItem("token");
    if (!token) {
      setError("No token found. Please log in."); // ------------------------------------- navigate user
      return;
    }

    try {
 
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/user/sendMessage`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: propsData.firstName+" "+propsData.lastName,
            from: propsData.email,
            to: checklist.customerserviceemail, 
            subject: formData.subject,
            message: formData.message,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send message");
      }

      setSuccess(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error:", error);
      setError(error.message);
    }
  };

  const closeModel = () => {
    setIsModalOpen(false);
    setSuccess(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      to:checklist.customerserviceemail
    }));
  };
  return (
    <div onClick={()=>console.log(propsData)} className="pt-4 md:pb-4">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center md:text-left mb-3 md:mb-6 gap-3">
        <div className="flex flex-col md:flex-row md:gap-4 items-center">
          
          <h1 className="text-lg sm:text-xl md:text-3xl font-normal text-left flex flex-row">
           <span className="block md:hidden">Name :&nbsp;</span><span>{`${propsData?.firstName} ${propsData?.lastName}`}</span>
          </h1>

          {propsData.uniqueId && (
            <p className="pt-2">ID: {propsData.uniqueId}</p>
          )}
        </div>
        {!!checklist?.customerserviceemail && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-[#036494] text-white px-5 py-2 rounded-full font-light transition-colors md:px-7 md:py-2 block hover:bg-[#025177]"
          >
            Contact Support
          </button>
        )}
      </div>

      {/* Desktop View (Table Layout) */}
      <div className="hidden lg:grid grid-cols-7 text-[15px] gap-4 text-[#1E1E1E] font-medium p-4 pb-2 rounded-lg">
        <div className="min-w-0 break-words">Contact Name</div>
        <div className="min-w-0 break-words">Date</div>
        <div className="min-w-0 break-words">Phone No.</div>
        <div className="min-w-0 break-words">From</div>
        <div className="min-w-0 break-words">Visa Type</div>
        <div className="min-w-0 break-words">Status</div>
        <div className="min-w-0 break-words">Country Of Interest</div>
      </div>

      {/* Data Section */}
      <div className="rounded-lg p-4 text-[15px] bg-[#FFFBF5] border border-[#CAC3BB] py-6 overflow-x-auto">
        {/* Desktop View */}
        <div className="hidden lg:grid grid-cols-7 gap-4 items-center text-center md:text-left">
          <div className="min-w-0 max-w-[150px] xl:max-w-[180px] whitespace-normal break-all">{`${propsData.firstName} ${propsData.lastName}`}</div>
          <div className="min-w-0 whitespace-normal break-all">
            {id === "new"
              ? moment().format("DD/MM/YY")
              : moment(propsData.date).format("DD/MM/YY")}
          </div>
          <div className="min-w-0 max-w-[140px] xl:max-w-[170px] whitespace-normal break-all">{id === "new" ? propsData.phone : propsData.mobileNumber}</div>
          <div className="min-w-0 max-w-[140px] xl:max-w-[170px] whitespace-normal break-all">{propsData.country || "-"}</div>
          <div className="min-w-0 max-w-[140px] xl:max-w-[170px] whitespace-normal break-all">{getVisaLabelByValue(propsData.visaCategory)  || "-"}</div>
          <div className="min-w-0 max-w-[140px] xl:max-w-[170px] whitespace-normal break-all">{newData.isSubmit ? "Submitted" : propsData.status || "-"}</div>
          <div className="min-w-0 max-w-[140px] xl:max-w-[190px] whitespace-normal break-all">{propsData.countryOfInterest || "-"}</div>
        </div>

        {/* Mobile View (Headings on Left) */}
        <div className="lg:hidden flex flex-col gap-3">
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">Contact Name:</span>
            <span className="min-w-0 whitespace-normal break-all">
              {id === "new"
                ? `${propsData.firstName} ${propsData.lastName}`
                : propsData.fullName}
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">Date:</span>
            <span className="min-w-0 whitespace-normal break-all">
              {id === "new"
                ? moment().format("DD/MM/YY")
                : moment(propsData.date).format("DD/MM/YY")}
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">Phone No.:</span>
            <span className="min-w-0 whitespace-normal break-all">
              {id === "new" ? propsData.phone : propsData.mobileNumber}
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">From:</span>
            <span className="min-w-0 whitespace-normal break-all">{propsData.country || "-"}</span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">Visa Type:</span>
            <span className="min-w-0 whitespace-normal break-all">{getVisaLabelByValue(propsData.visaCategory) || "-"}</span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">Status:</span>
            <span className="min-w-0 whitespace-normal break-all">{newData.isSubmit ? "Submitted" : propsData.status || "-"}</span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <span className="font-medium text-[#1E1E1E]">
              Country Of Interest:
            </span>
            <span className="min-w-0 whitespace-normal break-all">{propsData.countryOfInterest || "-"}</span>
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start sm:items-center justify-center p-4 overflow-y-auto z-50 text-sm md:text-base">
          <div className="bg-white rounded-lg w-full max-w-md relative max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-end pr-4 pt-4">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setSuccess(false);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <IoClose size={24} />
              </button>
            </div>

            {success ? (
              // Show success message modal
              <div className="p-12 w-full max-w-md text-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FiCheckCircle className="h-16 w-16 text-[#036494]" />
                </div>
                <h2 className="text-base font-medium mb-6">
                  Your message has been successfully delivered to the agent.
                </h2>
                <button
                  onClick={closeModel}
                  className="w-full bg-[#036494] text-white py-2 rounded-full hover:bg-[#075985] transition-colors"
                >
                  Back
                </button>
              </div>
            ) : (
              // Show form if success is false
              <form
                onSubmit={handleSubmit}
                className="px-6 mb-6 space-y-2 md:space-y-4"
              >
                {/* Error Message */}

                <div className="space-y-1 md:space-y-2">
                  <label className="block text-[#1E1E1E]">Your Name</label>
                  <input
                    type="text"
                    name="name"
                    value={`${propsData?.firstName} ${propsData?.lastName}`}
                    readOnly
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#036494]"
                    required
                  />
                </div>

                <div className="space-y-1 md:space-y-2">
                  <label className="block text-[#1E1E1E]">Application Id</label>
                  <input
                    type="text"
                    // name="subject"
                    readOnly
                    value={propsData.uniqueId}
                    // onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#036494]"
                    // required
                  />
                </div>

                <div className="space-y-1 md:space-y-2">
                  <label className="block text-[#1E1E1E]">Your Email</label>
                  <input
                    type="email"
                    name="email"
                    value={propsData.email}
                    readOnly 
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#036494]"
                    required
                  />
                </div>

                <div className="space-y-1 md:space-y-2">
                  <label className="block text-[#1E1E1E]">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#036494]"
                    // required
                  />
                </div>

                <div className="space-y-1 md:space-y-2">
                  <label className="block text-[#1E1E1E]">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="6"
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#036494]"
                    // required
                  />
                </div>

                {error && <p className="text-red-600 text-start">{error}</p>}
                <button
                  type="submit"
                  className="w-[160px] bg-[#036494] text-white px-4 py-2 rounded-full hover:bg-[#025177] transition-colors"
                >
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
